<template>
    <p class="page-container"></p>
</template>

<style >
    .page-container {
        font-size: 25px;
        text-align: center;
        color: rgb(192, 204, 218);
    }
</style>
// <script>
//   window.location.href="https://prodbisgaptab.jnj.com/#/site/CONAPDNA/projects/487/workbooks"
// </script>

<script>
    import applicationUserManager from "../Auth/applicationusermanager";
    import {getServerInfo,getAccessLogs,getIds4UsersGrow,account_info_GetIndex} from '../api/api';
  
  export default {
        name: "Welcome",
         data() {
            return {
            }
        },
        mounted() {
            // window.open('https://prodbisgaptab.jnj.com/#/site/CONAPDNA/projects/487/workbooks');
            window.open('https://prodbisgaptab.jnj.com/#/site/JJVCAP/projects/985/workbooks');

        },
    }
</script>
